import axios from 'axios';
import { reset as resetForm, initialize } from 'redux-form';
import { BASE_API, USER_TOKEN } from 'config/consts';
import _ from 'lodash';
import types from './types';

const URL = `${BASE_API}/station-sales-info`;
const URL_PAGARME = `${BASE_API}/gateway-balance`;
const URL_DIGITAL_ACCOUNTS = `${BASE_API}/gateway-digital-accounts`;
const URL_TRANSFER_TOTAL_BALANCE = `${BASE_API}/gateway-transfers`;

/**
 * Resumo da estação (saldos e atividades de venda). `pageSize: 0` pede só o
 * resumo, sem a lista de pedidos. A tela Vendas conta as vendas pela lista
 * unificada (Relatório de Vendas), que inclui links e assinaturas.
 *
 * `silencioso` recarrega sem ligar o carregamento da página inteira.
 */
export const getList = (stationId, filtros = {}, opcoes = {}) => {
  return (dispatch) => {
    if (!opcoes.silencioso) {
      dispatch({ type: types.LIST_LOAD, payload: true });
    }
    axios
      .get(`${URL}/${stationId}`, {
        params: {
          pageSize: 0,
          startDate: filtros.startDate || undefined,
          endDate: filtros.endDate || undefined,
        },
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: types.LIST_FETCHED,
            payload: response,
          },
        ]);
      })
      .catch((e) => {
        dispatch([
          { type: types.LIST_LOAD, payload: false },
          {
            type: 'SNACKBAR',
            payload: {
              message: e?.response?.data?.message || 'Não foi possível carregar as vendas.',
              variant: 'error',
              open: true,
            },
          },
        ]);
      });
  };
};

export const getPagarmeData = (id, router) => {
  return (dispatch) => {
    dispatch({ type: types.PAGARME_LOAD, payload: true });
    axios
      .get(`${URL_PAGARME}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: types.PAGARME_FETCHED,
            payload: response.data,
          },
        ]);
      })
      .catch((e) => {
        dispatch({ type: types.PAGARME_LOAD, payload: false });
        try {
          if (e.response.data.message) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `${e.response.data.message}`,
                variant: 'error',
                open: true,
              },
            });
            if (
              e.response.data.message ===
              'Seu estabelecimento ainda não possui uma conta bancária para depósito.'
            ) {
              if (router) {
                router.push('/owner/profile');
              }
            }
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro interno do sistema`,
              variant: 'error',
              open: true,
            },
          });
        }
      });
  };
};

export const getDigitalAccount = (id, router) => {
  return (dispatch) => {
    axios
      .get(`${URL_DIGITAL_ACCOUNTS}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: types.DIGITAL_ACCOUNT_FETCHED,
            payload: response.data,
          },
        ]);
        dispatch({ type: types.DIGITAL_ACCOUNT_LOADING, payload: false });
      })
      .catch((e) => {
        dispatch({ type: types.DIGITAL_ACCOUNT_LOADING, payload: false });

        console.log(e);
        try {
          if (e.response.data.message) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `${e.response.data.message}`,
                variant: 'error',
                open: true,
              },
            });
            if (
              e.response.data.message ===
              'Seu estabelecimento ainda não possui uma conta bancária para depósito.'
            ) {
              if (router) {
                router.push('/owner/profile');
              }
            }
          }
        } catch (error) {
          console.log(error);
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro interno do sistema`,
              variant: 'error',
              open: true,
            },
          });
        }
      })
      .finally(() => {
        dispatch({ type: types.PAGARME_LOAD, payload: false });
      });
  };
};

export const transferTotalBalance = (id, cleanup, router) => {
  return (dispatch) => {
    dispatch({ type: types.BUTTON_LOAD, payload: true });
    axios
      .post(
        `${URL_TRANSFER_TOTAL_BALANCE}`,
        { establishment_id: id },
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then((response) => {
        dispatch({ type: types.BUTTON_LOAD, payload: false });
        if (cleanup) {
          cleanup();
        }
      })
      .catch((e) => {
        dispatch({ type: types.BUTTON_LOAD, payload: false });

        console.log(e);
        try {
          if (e.response.data.message) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `${e.response.data.message}`,
                variant: 'error',
                open: true,
              },
            });
            if (
              e.response.data.message ===
              'Seu estabelecimento ainda não possui uma conta bancária para depósito.'
            ) {
              if (router) {
                router.push('/owner/profile');
              }
            }
          }
        } catch (error) {
          console.log(error);
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro interno do sistema`,
              variant: 'error',
              open: true,
            },
          });
        }
      });
  };
};

export const remove = (id, resolve, reject, other = undefined) => {
  return (dispatch) => {
    dispatch({ type: types.LIST_LOAD, payload: false });
    axios
      .delete(`${URL}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'SNACKBAR',
            payload: {
              message: 'Operação realizada com sucesso',
              variant: 'success',
              open: true,
            },
          },
          {
            type: types.LIST_LOAD,
            payload: false,
          },

          resolve(),
          getList(other),
        ]);
      })
      .catch((e) => {
        try {
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro: ${e.response.data.message}`,
              variant: 'error',
              open: true,
            },
          });
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
        reject();
      });
  };
};

export const getDetail = (id) => {
  return (dispatch) => {
    axios
      .get(`${URL}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        const initialValues = {
          ...response.data[0],
        };
        dispatch([
          {
            type: types.ITEM_DETAIL,
            payload: response.data[0],
          },
          initializeForm(initialValues),
        ]);
      });
  };
};

export const setDetail = (values) => {
  return (dispatch) => {
    const initialValues = {
      ...values,
    };
    dispatch([
      {
        type: types.ITEM_DETAIL,
        payload: { data: values },
      },
      initializeForm(initialValues),
    ]);
  };
};

export const initializeForm = (values) => {
  return initialize('categoriesForm', values);
};

export const reset = () => {
  return resetForm('categoriesForm');
};

export const create = (values, router, firstTime) => {
  return submit(values, 'post', router, firstTime);
};

export const update = (values, router) => {
  return submit(values, 'put', router);
};

function submit(values, method, router = undefined, firstTime) {
  const id = values.id ? `${values.id}/` : '';
  return (dispatch) => {
    dispatch([
      { type: types.BUTTON_LOAD, payload: true },
      { type: 'SUBMIT_PROGRESS', payload: 1 },
    ]);
    axios[method](`${URL}/${id}`, values, {
      headers: {
        Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
      },
      onUploadProgress: (progressEvent) =>
        dispatch([
          {
            type: 'SUBMIT_PROGRESS',
            payload: `${Math.round((progressEvent.loaded * 100) / progressEvent.total)} %`,
          },
        ]),
    })
      .then((response) => {
        /* dispatch([reset(), getList()]); */
        dispatch([
          { type: types.BUTTON_LOAD, payload: false },
          {
            type: 'SUBMIT_PROGRESS',
            payload: 0,
          },
          {
            type: 'SNACKBAR',
            payload: {
              message: 'Operação realizada com sucesso',
              variant: 'success',
              open: true,
            },
          },
        ]);

        if (!_.isUndefined(router)) {
          if (firstTime) {
            router.push('/admin');
          } else {
            router.push('/admin/categorias');
          }
        }
      })
      .catch((e) => {
        dispatch([
          { type: types.BUTTON_LOAD, payload: false },
          {
            type: 'SUBMIT_PROGRESS',
            payload: 0,
          },
        ]);

        try {
          for (const i in e.response.data) {
            for (const j in e.response.data[i]) {
              dispatch({
                type: 'SNACKBAR',
                payload: {
                  message: `${i}: ${e.response.data.errors[i][j]}`,
                  variant: 'error',
                  open: true,
                },
              });
            }
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
}

export const setLoading = (bool) => {
  return (dispatch) => {
    dispatch({
      type: types.LIST_LOAD,
      payload: false,
    });
  };
};

export const fileRejected = () => {
  return (dispatch) => {
    dispatch({
      type: 'SNACKBAR',
      payload: {
        message: 'Erro: Imagem maior que 2MB',
        variant: 'error',
        open: true,
      },
    });
  };
};
